export const lzFNotificationsMessageRemove = (msgNode: HTMLElement): void => {
    try {
        msgNode.className += ' lz-notifications-message-disappear';
        window.setTimeout(() => msgNode.remove(), 500);
    } catch (e: any) {}
};

(window as any).lzFNotificationsMessageRemove = lzFNotificationsMessageRemove;
